import { FC, MouseEventHandler, PropsWithChildren, useContext } from "react";

import {
  DroppableRideWrapper,
  IGridRowProps,
  TableWrapperContext,
} from "@ryde/controls";
import { DragTypeEnum, DropTypeEnum, IRideTableDto } from "@ryde/shared";

interface IGridRowDroppableProps extends PropsWithChildren {
  isDroppable: boolean;
  droppableId: string;
  className: string;
  row: IGridRowProps<IRideTableDto>["row"];
  onRowClick?: MouseEventHandler<HTMLTableRowElement>;
}

export const GridRowDroppable: FC<IGridRowDroppableProps> = ({
  isDroppable,
  children,
  droppableId,
  className,
  row,
  onRowClick,
}: IGridRowDroppableProps) => {
  const { isRidesEditOrAddRoute } = useContext(TableWrapperContext);
  const ride = row.original;

  if (isDroppable) {
    return (
      <DroppableRideWrapper
        id={droppableId}
        disabled={isRidesEditOrAddRoute}
        element="tr"
        useMaxSize={false}
        customClassName={className}
        onClick={onRowClick}
        dropData={{
          accepts: [DragTypeEnum.GRID_PASSENGER, DragTypeEnum.GRID_RIDE],
          typeDrop: DropTypeEnum.GRID_RIDE_DROP,
          rideDrop: ride,
        }}
      >
        {children}
      </DroppableRideWrapper>
    );
  }

  return (
    <tr className={className} onClick={onRowClick}>
      {children}
    </tr>
  );
};
